<template>
  <div>
    <vx-card titleIcon="SearchIcon" ref="filterCard" title="Adjust Log Summary" class="user-list-filters mb-8" :collapse-action="true">
      <FinishedProductAdjustStockLogSummary/>
    </vx-card>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="FINISHED PRODUCT STOCK">
          <template slot="actions">
            <vs-button @click.stop="onClickDownloadFullSheet()" class="mr-4 mb-4" color="primary" type="filled">Download Stock Inventory Audit Log</vs-button>
          </template>
          <div slot="no-body" class="mt-4" v-can="'view-product-stock-inventory'">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table
              id="finished-product-list-table"
              :max-items="(meta.per_page) ? meta.per_page : 10"
              :data="items"
              sort
              :sst="true"
              stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th width="20%"  class="text-xs" sort-key="formulation_code">ITS PRODUCT CODE</vs-th>
                <vs-th width="20%"  class="text-xs" sort-key="name">ITS PRODUCT NAME</vs-th>
                <vs-th width="15%" class="text-xs">TOTAL QTY (KG)</vs-th>
                <vs-th width="15%" class="text-xs">COMPLETED QTY (KG)</vs-th>
                <vs-th width="15%" class="text-xs">MANUFACTURING DATE</vs-th>
                <vs-th width="15%" class="text-xs">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr @click.native="onClickStockChange(data[indextr].id)" class="text-sm" style="cursor: pointer"  :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code}}
                  </vs-td>

                  <vs-td :data="data[indextr].formulation_name">
                    {{ data[indextr].formulation_name}}
                  </vs-td>


                  <vs-td class="font-bold" :data="data[indextr].total_quantity">
                    {{ data[indextr].total_quantity}}
                  </vs-td>

                  <vs-td class="font-bold" :data="data[indextr].completed_quantity">
                    {{ data[indextr].completed_quantity}}
                  </vs-td>

                  <vs-td class="font-bold" :data="data[indextr].manufacture_date">
                    {{ data[indextr].manufacture_date}}
                  </vs-td>

                  <vs-td>
                    <div class="vx-row">
                      <vx-tooltip text="View Activity Log" position="left">
                        <vs-button class="ml-3"
                                   @click.STOP="onClickStockChange(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip text="Download Log" position="left">
                        <vs-button class="ml-3"
                                   @click.stop="onClickDownloadSheet(data[indextr].id)"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-download"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>


            </vs-table>

            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </vx-card>
      </div>
    </div>
    <finished-product-stock-adjust-log-popup ref="finishedProductStockAdjustLogPopup" />
    <download-inventory-log-pop-up ref="downloadInventoryLogPopUp"/>
    <DownloadInventoryChangeLogPopUp ref="downloadInventoryChangeLogPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import {defaultPagination, perPageList} from "@/constants/config";
  import FinishedProductStockAdjustLogPopup
    from "@/components/popups/activity-logs/stock-adjust/FinishedProductStockAdjustLogPopup";
  import DownloadInventoryLogPopUp from '@/components/popups/activity-logs/inventory/DownloadInventoryLogPopUp.vue';
  import DownloadInventoryChangeLogPopUp from '@/components/popups/activity-logs/inventory/DownloadInventoryChangeLogPopUp.vue';
  import FinishedProductAdjustStockLogSummary from './FinishedProductAdjustStockLogSummary.vue';


  export default {
    name: 'FinishedProductAllBatchList',
    data () {
      return {
        items: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
        activePrompt: false,
        current_stock_level: '',
        selected_product_id: ''
      }
    },
    components: {
      'v-select': vSelect,
      FinishedProductStockAdjustLogPopup,
      DownloadInventoryLogPopUp,
      DownloadInventoryChangeLogPopUp,
      FinishedProductAdjustStockLogSummary
    },
    mixins : [Filter, SuccessMessage, ErrorMessages],
    methods: {
      async refreshData () {
        this.fetchProductStockList()
      },
      async fetchProductStockList() {
        await this.$vs.loading({
          container: '#finished-product-list-table',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getFormulationStock(this.page, this.filterQuery, this.perPage)
          this.items =  data.data
          this.meta = data.meta
        } catch (e) {
          this.showWarningMessage('Something went wrong. Please try again!')
        }
        this.$vs.loading.close('#finished-product-list-table > .con-vs-loading')
      },

      filterQueryUpdate (){
        this.fetchProductStockList()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchProductStockList()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchProductStockList()
        }

      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },

      onClickStockChange(id) {
        this.$refs.finishedProductStockAdjustLogPopup.openPopup(id)
      },
      onClickDownloadSheet(id) {
        this.$refs.downloadInventoryLogPopUp.openPopup(id, 'formulation-inventory')
      },
      async onClickDownloadFullSheet() {
        this.$refs.downloadInventoryChangeLogPopUp.openPopup('formulation-inventory')
      },
    },
    watch : {
      page(){
        this.fetchProductStockList()
      },
      perPage() {
        this.fetchProductStockList()
      }
    }
  }
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
</style>
